import {
  SlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import { ActivityEditColumn } from './activityEditColumn';
import { ActivityReassignColumn } from './activityReassignColumn';

export const ActivityReassign = () => {

  const leftColumn = {
    title: 'issue.menu.edit',
    mainComponent: (
      <ActivityEditColumn />
    ),
    showBackButton: true,
    disableScroll: true,
  };

  const rightColumn = {
    title: 'issue.menu.reassign',
    mainComponent: (
      <ActivityReassignColumn />
    ),
    showBackButton: true,
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
